module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.14caa659.ttf";